<template>
  <div class="parentList">
    <div class="parentList-main flex">
      <main-left only-school @treeNodeClick="treeNodeClick" />
      <div class="parentList-right flex_1 div-layout">
        <module-title title="家长列表" />
        <div class="list-top">
          <p>{{ treeNode.name }}</p>
          <el-form ref="searchForm" :model="searchForm" :inline="true" size="small">
            <el-form-item prop="type">
              <el-select v-model="searchForm.type" placeholder="选择" class="selectStyle" @change="changeType">
                <el-option label="学生姓名" value="1" />
                <el-option label="学生编号" value="2" />
                <el-option label="家长手机号" value="3" />
                <el-option label="设备IMEI" value="4" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-show="searchForm.type=='1'" v-model.trim="searchForm.studentName" maxlength="15" clearable placeholder="输入关键字" />
            </el-form-item>
            <el-form-item>
              <el-input v-show="searchForm.type=='2'" v-model.trim="searchForm.studentNo" maxlength="30" clearable placeholder="输入关键字" />
            </el-form-item>
            <el-form-item>
              <el-input v-show="searchForm.type=='3'" v-model.trim="searchForm.phone" maxlength="11" name="phone" clearable placeholder="输入关键字" @change="inputNum($event,'phone')" @input="inputNum($event,'phone')" />
            </el-form-item>
            <el-form-item>
              <el-input v-show="searchForm.type=='4'" v-model.trim="searchForm.imei" maxlength="30" clearable placeholder="输入关键字" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearchFilter">
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table v-loading="listLoading" :data="parentList" fit element-loading-text="Loading" class="list-table" highlight-current-row>
          <el-table-column label="设备编号" prop="deviceNo" align="center" />
          <el-table-column label="设备型号" prop="deviceType" align="center" />
          <el-table-column label="设备IMEI" prop="imei" align="center" />
          <el-table-column label="绑定学生" prop="stuName" align="center" />
          <el-table-column label="学生编号" prop="stuNum" align="center" />
          <el-table-column label="绑定家长" align="center">
            <template slot-scope="scope">
              {{ scope.row.parentName }}<span v-if="scope.row.parentName && scope.row.admin == 1">({{ scope.row.admin == 1 ?'管理员':'' }})</span>
            </template>
          </el-table-column>
          <el-table-column label="家长手机号" prop="mobile" align="center" />
          <el-table-column label="绑定时间" prop="createDate" align="center" />
        </el-table>
        <pagination
          :total="page.total"
          :page.sync="page.pageNum"
          :limit.sync="page.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getBindDevicesPage } from '@/api/systemMaintenance/devicManage/schoolCardManage';
export default {
  data() {
    return {
      treeNode: {},
      searchForm: {
        type: '1',
        studentName: '',
        studentNo: '',
        phone: '',
        imei: '',
        schoolCode: ''
      },
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      listLoading: false,
      parentList: [],
      op: {}
    };
  },
  methods: {
    inputNum(value, item) {
      this.searchForm[item] = value.replace(/^\.+|[^\d.]/g, '');
    },
    // 树点击事件
    treeNodeClick(data) {
      this.treeNode = data;
      this.searchForm.schoolCode = data.code;
      this.getTableList();
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.op = {
        studentName: this.searchForm.studentName,
        studentNumber: this.searchForm.studentNo,
        parentMobile: this.searchForm.phone,
        deviceImei: this.searchForm.imei
      };
      this.getTableList();
    },
    changeType() {
      if (this.searchForm.type === '1') {
        this.searchForm.studentNo = '';
        this.searchForm.phone = '';
        this.searchForm.imei = '';
      } else if (this.searchForm.type === '2') {
        this.searchForm.studentName = '';
        this.searchForm.phone = '';
        this.searchForm.imei = '';
      } else if (this.searchForm.type === '3') {
        this.searchForm.studentNo = '';
        this.searchForm.studentName = '';
        this.searchForm.imei = '';
      } else {
        this.searchForm.studentNo = '';
        this.searchForm.phone = '';
        this.searchForm.studentName = '';
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getBindDevicesPage({ pageNum: this.page.pageNum, pageSize: this.page.pageSize, schoolCode: this.searchForm.schoolCode, ...this.op }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.parentList = [];
          this.page.total = 0;
        } else {
          this.parentList = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        this.listLoading = false;
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.parentList{
    .list-top{
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: bold;
            color: #666666;
            margin-bottom: 20px;
        }
        .selectStyle{
          width: 120px;
          margin-left: 20px;
        }
    }
}
</style>
